export default "__VITE_ASSET__rLxe$irc__"